<template>
    <div>
        <CRow>
            <CCol>
                <ejs-grid ref='grid'
                          :dataSource='m2mData'
                          :allowFiltering='true'
                          :allowPaging='true'
                          :allowResizing='true'
                          :allowReordering='true'
                          :allowSorting='true'
                          :toolbar='toolbar'
                          :editSettings='editSettings'
                          :pageSettings='pageSettings'
                          :filterSettings='filterOptions'
                          :toolbarClick='toolbarClick'
                          :allowExcelExport='true'
                          :excelExportComplete='excelExportComplete'
                          :query='gridQuery'
                          :actionFailure="actionFailure"
                          :actionComplete="actionComplete"
                          :actionBegin="actionBegin">
                    <e-columns>
                        <e-column field='m2MReferenceDateId' headerText='Id' :isPrimaryKey='true' :visible='false'></e-column>
                        <e-column field='contractTradeablePeriodId' headerText='ContractTradeablePeriod' :visible='false'></e-column>
                        <e-column field='tradablePeriod' headerText='Tradeable Period' width=120 :allowEditing="false"></e-column>
                        <e-column field='startDate' headerText='Start Date' width=120 :validationRules="{ required: false }" :format='dateFormatOptions' type='date' :edit="dpsParams"></e-column>
                        <e-column field='endDate' headerText='End Date' :format='dateFormatOptions' :validationRules="{ required: false }" type='date' :edit="dpeParams" width=120></e-column>
                    </e-columns>
                </ejs-grid>
                <div id="modalTarget" class="control-section; position:relative" style="height:350px;">
                    <ejs-uploader ref="uploadObj" 
                                  id='defaultfileupload' 
                                  name="uploadFile" 
                                  :allowedExtensions="extensions" 
                                  :uploading="addHeaders" 
                                  :asyncSettings="path" 
                                  :success="onUploadSuccess" 
                                  :failure="onUploadFailed" 
                                  :multiple='multiple'>
                    </ejs-uploader>
                </div>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { DatePickerPlugin, DatePicker } from '@syncfusion/ej2-vue-calendars';
    import { UploaderPlugin } from "@syncfusion/ej2-vue-inputs";
    import { DialogUtility } from '@syncfusion/ej2-vue-popups';
    import SyncHelper from '../../common/syncfusion'
    import gridOptions from '../../common/gridOptions'
    import store from '../../store';
    import { Query } from '@syncfusion/ej2-data'
    import apis from '../../common/network'
    import urls from '../../common/urls'
    import authToken from '../../common/authToken';


    Vue.use(GridPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(DatePickerPlugin);
    Vue.use(DialogUtility);

    let dpsObj, dpsElem, dpeObj, dpeElem;
    export default {
        name: 'M2MReferenceDatesForm',
        created() {
        },
        data() {
            return {
                m2mData: SyncHelper.getDataManager("M2MReferenceDate"),
                pageSettings: gridOptions.pageSettings,
                gridQuery: new Query().addParams("contractId", store.state.selectedContractId),
                maxDeadlineDate: null,
                editSettings: {
                    showConfirmDialog: true,
                    allowEditing: store.state.permissions["Permissions.M2MReferenceDate.Update"],
                    mode: 'Normal'
                },
                toolbar: ['Edit', 'ExcelExport'],
                filterOptions: gridOptions.filterSettings,
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy' },
                path: {
                    saveUrl: `${urls.apiBaseUrl}M2MReferenceDate/import?contractId=${store.state.selectedContractId}`
                },
                extensions: ' .xls, .xlsx',
                multiple: false,
                addHeaders: function (args) {
                    args.currentRequest.setRequestHeader('Authorization', `Bearer ${authToken.get()}`);
                },
                dpsParams: {
                    create: function () {
                        dpsElem = document.createElement('input');
                        return dpsElem;
                    },
                    read: () => {
                        return dpsObj.value;
                    },
                    destroy: () => {
                        dpsObj.destroy();
                    },
                    write: (args) => {
                        dpsObj = new DatePicker({
                            value: args.rowData[args.column.field] ? new Date(args.rowData[args.column.field]) : null,
                            floatLabelType: 'Always',
                            format: 'dd/MM/yyyy',
                            placeholder: 'Start Date',
                            firstDayOfWeek: 1,
                        });
                        dpsObj.appendTo(dpsElem);
                    }
                },
                dpeParams: {
                    create: function () {
                        dpeElem = document.createElement('input');
                        return dpeElem;
                    },
                    read: () => {
                        return dpeObj.value;
                    },
                    destroy: () => {
                        dpeObj.destroy();
                    },
                    write: (args) => {
                        dpeObj = new DatePicker({
                            value: args.rowData[args.column.field] ? new Date(args.rowData[args.column.field]) : null,
                            floatLabelType: 'Always',
                            format: 'dd/MM/yyyy',
                            placeholder: 'End Date',
                            firstDayOfWeek: 1,
                        });
                        dpeObj.appendTo(dpeElem);
                    }
                },
            }
        },
        methods: {
            toolbarClick(args) {
                if (args.item.id.includes('excelexport')) {
                    this.$refs.grid.getColumns()[0].visible = true;
                }
                gridOptions.excelExport(args, "PerformanceWatchWindow.xlsx", this.$refs);
            },
            fixDateOffset: function (date) {
                date.setHours(date.getHours() - (date.getTimezoneOffset() / 60));
                return date;
            },
            excelExportComplete(args) {
                this.$refs.grid.getColumns()[0].visible = false;
                this.$refs.grid.hideSpinner();
            },
            actionBegin(args) {
                if (args.requestType === 'beginEdit') {
                    apis.protectedApi(`${urls.apiBaseUrl}ContractTrigger/PeriodDeadline/${args.rowData.contractTradeablePeriodId}`).then(it => {
                        let dateArray = it.data.lastDay.split("/");
                        let newLastDate = dateArray[1] + '/' + dateArray[0] + '/' + dateArray[2];
                        dpeObj.max = new Date(newLastDate);
                        dpsObj.max = new Date(newLastDate);
                        //dpeObj.max = new Date(it.data.lastDay);
                        //dpsObj.max = new Date(it.data.lastDay);
                    }).catch(
                        response => {
                            var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                            gridOptions.errorAlert("Error: " + message);
                        }
                    );
                }
                if (args.requestType === 'save') {

                    //apis.protectedApi(`${urls.apiBaseUrl}M2MReferenceDate/CheckDatesForTradeablePeriods/${args.rowData.tradablePeriod}`).then(it => {
                    //    dpeObj.max = new Date(it.data.lastDay);
                    //    dpsObj.max = new Date(it.data.lastDay);
                    //}).catch(
                    //    response => {
                    //        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                    //        gridOptions.errorAlert("Error: " + message);
                    //    }
                    //);
                    if (dpsObj.value) {
                        dpsObj.value.setHours(0, 0, 0, 0);
                    }
                    if (dpeObj.value) {
                        dpeObj.value.setHours(0, 0, 0, 0);
                    }

                    if (dpsObj.value && !dpeObj.value) {
                        dpeObj.value = dpeObj.max;
                        args.data.endDate = dpeObj.max;
                    }

                    if (dpsObj.value > dpsObj.max) {
                        gridOptions.errorAlert("Start Date must be before the start of the Tradeable Period.");
                        args.cancel = true;
                    }
                    if (dpeObj.value > dpeObj.max) {
                        gridOptions.errorAlert("End Date must be before the start of the Tradeable Period.");
                        args.cancel = true;
                    }
                    if (!dpsObj.value && dpeObj.value) {
                        gridOptions.errorAlert("Start Date is required when End Date is selected.");
                        args.cancel = true;
                    }
                    if (dpsObj.value && !dpeObj.value) {
                        gridOptions.errorAlert("End Date is required when Start Date is selected.");
                        args.cancel = true;
                    }
                    if (dpsObj.value && dpeObj.value && dpeObj.value <= dpsObj.value) {
                        gridOptions.errorAlert("Start Date must be before the End Date.");
                        args.cancel = true;
                    }
                    if (dpsObj.value) {
                        args.data.startDate = this.fixDateOffset(dpsObj.value);
                    }
                    if (dpeObj.value) {
                        args.data.endDate = this.fixDateOffset(dpeObj.value);
                    }
                }
                
            },
            actionComplete(args) {
                if (args.requestType === 'save') {
                    this.$refs.grid.refresh();
                }
            },
            onUploadFailed: function (args) {
                this.$refs.grid.refresh();
                var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                args.statusText = statusMessage.trim();
            },
            actionFailure(args) {
                console.log(args);
                gridOptions.actionFailure(args);
            },
            onUploadSuccess: function (args) {
                if (JSON.parse(args.e.currentTarget.response).status === "OK with Errors") {
                    let fileName = JSON.parse(args.e.currentTarget.response).file.fileDownloadName;
                    let base64String = JSON.parse(args.e.currentTarget.response).file.fileContents;
                    const byteCharacters = atob(base64String);
                    const byteNumbers = new Uint8Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }

                    const blob = new Blob([byteNumbers], { type: 'application/octet-stream' });
                    const url = window.URL.createObjectURL(blob);
                    const element = document.createElement('a');
                    element.href = url;
                    element.download = fileName;
                    document.body.appendChild(element);
                    element.click();
                    element.remove();
                    window.URL.revokeObjectURL(url);
                    var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                    args.statusText = statusMessage.trim();
                }
                this.$refs.grid.refresh();
            },
        },
        computed: {
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    }
</script>

<style scoped>
</style>